import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/login_top_img.png'


const _hoisted_1 = {
  class: "common_layout",
  style: {"padding-left":"48px","padding-right":"48px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "center_flex_layout",
  style: {"margin-top":"100px"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"184px","height":"154px"},
    src: _imports_0
  })
], -1)

import { reactive, ref, Ref, onMounted, getCurrentInstance } from "vue";
import { post } from "../utils/request";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const router = useRouter();
const { proxy }: any = getCurrentInstance();

const account = reactive({ value: "" });
const password = reactive({ value: "" });

const toLogin = () => {
	proxy.$limit(toLoginRequire, 3000);
};

const toLoginRequire = () => {
	if (!account.value) {
		proxy.$toast("請輸入賬號");
		return;
	}

	if (!password.value) {
		proxy.$toast("請輸入密碼");
		return;
	}

	post(
		`/auth/form?username=${account.value}&password=${password.value}`,
		{},
		{
			"Content-Type": "application/json",
			Authorization: "Basic TUFOQUdFTUVOVDowMDAwMDA=",
		}
	)
		.then((res) => {
			// console.log(JSON.stringify(res));
			if (res.code === 1) {
				proxy.$toast("登入成功");
				// localStorage.setItem('userName',account.value);
				localStorage.setItem("access_token", res.result.access_token);
				router.push("/managerHome");
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_input, {
      "prefix-icon": "User",
      size: "large",
      class: "common_font",
      style: {"margin-top":"38px"},
      modelValue: account.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((account.value) = $event)),
      placeholder: "請輸入賬號"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_input, {
      "prefix-icon": "Lock",
      size: "large",
      class: "common_font",
      style: {"margin-top":"40px"},
      modelValue: password.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password.value) = $event)),
      placeholder: "請輸入密碼",
      type: "password",
      "show-password": ""
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      type: "primary",
      style: {"width":"100%","margin-top":"150px"},
      size: "large",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (toLogin()))
    }, {
      default: _withCtx(() => [
        _createTextVNode("登入")
      ]),
      _: 1
    })
  ]))
}
}

})